module.exports = __webpack_public_path__ + "static/simple-bar-ee8af8be8c5257da0813c89ecd56ef31.png";